import TagGroupSection from 'components/Tags/TagGroupSection';
import useActions from 'hooks/useActions';
import { useNavigate } from 'react-router-dom';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        episode: state.vhsEpisodes.selectedEpisode,
        tagGroups: state.vhsEpisodes.tagGroups,
    };
}

const EpisodesTags = connect(mapStateToProps)(function (props) {
    const { episode, tagGroups } = props;
    const {
        VHS_ADD_TAG_TO_EPISODE_REQUEST,
        VHS_REMOVE_TAG_FROM_EPISODE_REQUEST,
        VHS_SELECT_TAG_GROUP,
    } = useActions();

    const navigate = useNavigate();

    function onAdd(tagId) {
        VHS_ADD_TAG_TO_EPISODE_REQUEST({ episodeId: episode.id, tagId });
    }

    function onRemove(tagId) {
        VHS_REMOVE_TAG_FROM_EPISODE_REQUEST({ episodeId: episode.id, tagId });
    }

    function onSelectTagGroup(tagGroup) {
        VHS_SELECT_TAG_GROUP(tagGroup);
        navigate(`/vhs/tags/tag/new/${tagGroup.id}`);
    }

    return (
        <section>
            {tagGroups &&
                tagGroups.map((tagGroup) => (
                    <TagGroupSection
                        key={tagGroup.id}
                        tagGroup={tagGroup}
                        selectedTags={episode?.tags}
                        onAdd={onAdd}
                        onRemove={onRemove}
                        onSelectTagGroup={onSelectTagGroup}
                    />
                ))}
        </section>
    );
});

export default EpisodesTags;
